/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateTestAccountRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {CreateTestAccountResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const createTestAccount = (request: CreateTestAccountRequest, options?: CashRequestOptions) => post<CreateTestAccountRequest, CreateTestAccountResponse>("/2.0/cash/create-test-account", request, {...options, rejectOnError: true })